import {
  getProfile,
  selectProfile,
  selectProfileError,
  selectProfileHasError,
  selectProfileIsLoaded,
} from 'state/modules/profiles';
import waitForSaga from 'helpers/waitForSaga';
import { checkForProfileRedirect } from 'helpers/profiles/redirects';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const CustomProfileDirectories = () => null;

const getErrorStatusCode = (store, directory) => {
  const profileStatusIsError = selectProfileHasError(store.getState(), directory);

  if (profileStatusIsError) {
    const { statusCode } = selectProfileError(store.getState(), directory);

    if (statusCode) {
      return statusCode;
    }
  }

  return null;
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const {
        query: { dir1 },
        store,
      } = ctx;

      const directory = `/${dir1}`;
      const profileLoaded = selectProfileIsLoaded(store.getState(), directory);
      if (!profileLoaded) await store.dispatch(getProfile(directory));
      await waitForSaga(store);

      const errorCode = getErrorStatusCode(store, directory);

      const profile = selectProfile(store.getState(), directory);

      const redirect = checkForProfileRedirect(profile);
      if (redirect) {
        return redirect;
      }

      return {
        errorCode,
      };
    })
);

export default CustomProfileDirectories;
